<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher un utilisateur..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openCreateModal()">
                <span class="px-2">Nouveau</span>
            </button>
                </mat-card-subtitle>

    </mat-card-header>
<mat-card-content>
  <div class="method-steps-table">
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort>

        <!-- select Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="toggleSelectAll()" [checked]="isAllStepsSelected"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let step">
            <mat-checkbox [checked]="selectedSteps.includes(step)" (change)="toggleSelection(step)"></mat-checkbox>
          </td>
        </ng-container>


        <!-- Title Column -->
        <ng-container matColumnDef="titre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Titre </th>
          <td mat-cell *matCellDef="let step"> {{ step.titre }} </td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let step"> {{ step.description }} </td>
        </ng-container>

        <!-- Config Columns -->
        <ng-container matColumnDef="valeurApplicable">
          <th mat-header-cell *matHeaderCellDef> Valeur </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.valeurApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <ng-container matColumnDef="uniteApplicable">
          <th mat-header-cell *matHeaderCellDef> Unité </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.uniteApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <ng-container matColumnDef="commentaireApplicable">
          <th mat-header-cell *matHeaderCellDef> Commentaire </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.commentaireApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <ng-container matColumnDef="dateApplicable">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.dateApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <ng-container matColumnDef="statutApplicable">
          <th mat-header-cell *matHeaderCellDef> Statut </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.statutApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <ng-container matColumnDef="realiseApplicable">
          <th mat-header-cell *matHeaderCellDef> Réalisé </th>
          <td mat-cell *matCellDef="let step"> {{ step.fieldConfig?.realiseApplicable ? '✅' : '❌' }} </td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-center"> Action </th>
          <td mat-cell *matCellDef="let step">
            <div class="action-info text-center" style="justify-content: center !important;">
              <button mat-button matTooltip="Visualiser" (click)="viewStep(step)">
                <i class="material-symbols-outlined">visibility</i>
              </button>
              <button mat-button matTooltip="Modifier" (click)="editStep(step)">
                <i class="material-symbols-outlined text-primary">brush</i>
              </button>
              <button mat-button matTooltip="Supprimer" (click)="deleteStep(step)">
                <i class="material-symbols-outlined text-danger">delete</i>
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Header and Row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="12">Aucun résultat trouvé pour Method Steps</td>
        </tr>

      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</mat-card-content>


<!-- modal template for add Method Step -->
<ng-template #content let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">
          Créer une Étape de Méthode
        </h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="form" (ngSubmit)="saveMethodStep()">

        <div class="row">

          <!-- Titre -->
          <div class="col-sm-12 col-md-6 col-lg-4">
            <mat-form-field class="mb-25">
              <mat-label>Titre</mat-label>
              <input matInput formControlName="titre" required>
              <mat-error *ngIf="form.get('titre')?.hasError('required')">
                Titre requis
              </mat-error>
            </mat-form-field>
          </div>

                      

          <!-- Description -->
          <div class="col-sm-12 col-md-6 col-lg-8">
            <mat-form-field class="mb-25">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
          </div>

        </div>

        <hr>

        <!-- CONFIGURATION DES CHAMPS -->
        <h6>Configuration des champs de saisie</h6>

        <div formGroupName="fieldConfig" class="row">

          <div class="col-sm-12 col-md-4" *ngFor="let field of fieldConfigFields">
            <mat-slide-toggle [formControlName]="field.key">
              {{ field.label }}
            </mat-slide-toggle>
          </div>

        </div>

        <div class="col-sm-12 text-right mt-3">
          <button type="submit"
                  class="btn btn-outline-success">
            Enregistrer
          </button>
        </div>

      </form>
    </mat-card-content>
  </mat-card>
</ng-template>
</mat-card>